// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SalesforceConnectionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SalesforceConnectionQuery = { __typename?: 'Query', salesforceConnection?: { __typename?: 'SalesforceConnectionStatus', domain: string, connected: boolean, object?: string | null } | null };

export type SalesforceObjectsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SalesforceObjectsQuery = { __typename?: 'Query', salesforceObjects: Array<{ __typename?: 'SalesforceObject', name: string, label: string, queryable: boolean }> };

export type ConfigureSalesforceMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateIntegrationConfigurationInput;
}>;


export type ConfigureSalesforceMutation = { __typename?: 'Mutation', updateIntegrationConfiguration?: { __typename?: 'IntegrationConfiguration', id: string } | null };

export type VerifySalesforceMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type VerifySalesforceMutation = { __typename?: 'Mutation', verifySalesforce: boolean };

export type SetSalesforceHouseholdObjectMutationVariables = Types.Exact<{
  object: Types.Scalars['String']['input'];
}>;


export type SetSalesforceHouseholdObjectMutation = { __typename?: 'Mutation', setSalesforceHouseholdObject: boolean };

export type SetSalesforceWealthHubBrandingMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  isWealthHub: Types.Scalars['Boolean']['input'];
}>;


export type SetSalesforceWealthHubBrandingMutation = { __typename?: 'Mutation', updateIntegrationConfiguration?: { __typename?: 'IntegrationConfiguration', id: string, salesforceIsWealthhub: boolean } | null };

export const Operations = {
  Query: {
    SalesforceConnection: 'SalesforceConnection' as const,
    SalesforceObjects: 'SalesforceObjects' as const
  },
  Mutation: {
    ConfigureSalesforce: 'ConfigureSalesforce' as const,
    VerifySalesforce: 'VerifySalesforce' as const,
    SetSalesforceHouseholdObject: 'SetSalesforceHouseholdObject' as const,
    SetSalesforceWealthHubBranding: 'SetSalesforceWealthHubBranding' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const SalesforceConnectionDocument = gql`
    query SalesforceConnection {
  salesforceConnection {
    domain
    connected
    object
  }
}
    `;

/**
 * __useSalesforceConnectionQuery__
 *
 * To run a query within a React component, call `useSalesforceConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesforceConnectionQuery(baseOptions?: Apollo.QueryHookOptions<SalesforceConnectionQuery, SalesforceConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesforceConnectionQuery, SalesforceConnectionQueryVariables>(SalesforceConnectionDocument, withFetchPolicyContext(options));
      }
export function useSalesforceConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesforceConnectionQuery, SalesforceConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesforceConnectionQuery, SalesforceConnectionQueryVariables>(SalesforceConnectionDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useSalesforceConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SalesforceConnectionQuery, SalesforceConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SalesforceConnectionQuery, SalesforceConnectionQueryVariables>(SalesforceConnectionDocument, withFetchPolicyContext(options));
        }
export type SalesforceConnectionQueryHookResult = ReturnType<typeof useSalesforceConnectionQuery>;
export type SalesforceConnectionLazyQueryHookResult = ReturnType<typeof useSalesforceConnectionLazyQuery>;
export type SalesforceConnectionSuspenseQueryHookResult = ReturnType<typeof useSalesforceConnectionSuspenseQuery>;
export type SalesforceConnectionQueryResult = Apollo.QueryResult<SalesforceConnectionQuery, SalesforceConnectionQueryVariables>;
export const SalesforceObjectsDocument = gql`
    query SalesforceObjects {
  salesforceObjects {
    name
    label
    queryable
  }
}
    `;

/**
 * __useSalesforceObjectsQuery__
 *
 * To run a query within a React component, call `useSalesforceObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceObjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesforceObjectsQuery(baseOptions?: Apollo.QueryHookOptions<SalesforceObjectsQuery, SalesforceObjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesforceObjectsQuery, SalesforceObjectsQueryVariables>(SalesforceObjectsDocument, withFetchPolicyContext(options));
      }
export function useSalesforceObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesforceObjectsQuery, SalesforceObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesforceObjectsQuery, SalesforceObjectsQueryVariables>(SalesforceObjectsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useSalesforceObjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SalesforceObjectsQuery, SalesforceObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SalesforceObjectsQuery, SalesforceObjectsQueryVariables>(SalesforceObjectsDocument, withFetchPolicyContext(options));
        }
export type SalesforceObjectsQueryHookResult = ReturnType<typeof useSalesforceObjectsQuery>;
export type SalesforceObjectsLazyQueryHookResult = ReturnType<typeof useSalesforceObjectsLazyQuery>;
export type SalesforceObjectsSuspenseQueryHookResult = ReturnType<typeof useSalesforceObjectsSuspenseQuery>;
export type SalesforceObjectsQueryResult = Apollo.QueryResult<SalesforceObjectsQuery, SalesforceObjectsQueryVariables>;
export const ConfigureSalesforceDocument = gql`
    mutation ConfigureSalesforce($input: AugmentedUpdateIntegrationConfigurationInput!) {
  updateIntegrationConfiguration(input: $input) {
    id
  }
}
    `;
export type ConfigureSalesforceMutationFn = Apollo.MutationFunction<ConfigureSalesforceMutation, ConfigureSalesforceMutationVariables>;

/**
 * __useConfigureSalesforceMutation__
 *
 * To run a mutation, you first call `useConfigureSalesforceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureSalesforceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureSalesforceMutation, { data, loading, error }] = useConfigureSalesforceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureSalesforceMutation(baseOptions?: Apollo.MutationHookOptions<ConfigureSalesforceMutation, ConfigureSalesforceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureSalesforceMutation, ConfigureSalesforceMutationVariables>(ConfigureSalesforceDocument, options);
      }
export type ConfigureSalesforceMutationHookResult = ReturnType<typeof useConfigureSalesforceMutation>;
export type ConfigureSalesforceMutationResult = Apollo.MutationResult<ConfigureSalesforceMutation>;
export type ConfigureSalesforceMutationOptions = Apollo.BaseMutationOptions<ConfigureSalesforceMutation, ConfigureSalesforceMutationVariables>;
export const VerifySalesforceDocument = gql`
    mutation VerifySalesforce {
  verifySalesforce
}
    `;
export type VerifySalesforceMutationFn = Apollo.MutationFunction<VerifySalesforceMutation, VerifySalesforceMutationVariables>;

/**
 * __useVerifySalesforceMutation__
 *
 * To run a mutation, you first call `useVerifySalesforceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifySalesforceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifySalesforceMutation, { data, loading, error }] = useVerifySalesforceMutation({
 *   variables: {
 *   },
 * });
 */
export function useVerifySalesforceMutation(baseOptions?: Apollo.MutationHookOptions<VerifySalesforceMutation, VerifySalesforceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifySalesforceMutation, VerifySalesforceMutationVariables>(VerifySalesforceDocument, options);
      }
export type VerifySalesforceMutationHookResult = ReturnType<typeof useVerifySalesforceMutation>;
export type VerifySalesforceMutationResult = Apollo.MutationResult<VerifySalesforceMutation>;
export type VerifySalesforceMutationOptions = Apollo.BaseMutationOptions<VerifySalesforceMutation, VerifySalesforceMutationVariables>;
export const SetSalesforceHouseholdObjectDocument = gql`
    mutation SetSalesforceHouseholdObject($object: String!) {
  setSalesforceHouseholdObject(object: $object)
}
    `;
export type SetSalesforceHouseholdObjectMutationFn = Apollo.MutationFunction<SetSalesforceHouseholdObjectMutation, SetSalesforceHouseholdObjectMutationVariables>;

/**
 * __useSetSalesforceHouseholdObjectMutation__
 *
 * To run a mutation, you first call `useSetSalesforceHouseholdObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSalesforceHouseholdObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSalesforceHouseholdObjectMutation, { data, loading, error }] = useSetSalesforceHouseholdObjectMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useSetSalesforceHouseholdObjectMutation(baseOptions?: Apollo.MutationHookOptions<SetSalesforceHouseholdObjectMutation, SetSalesforceHouseholdObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSalesforceHouseholdObjectMutation, SetSalesforceHouseholdObjectMutationVariables>(SetSalesforceHouseholdObjectDocument, options);
      }
export type SetSalesforceHouseholdObjectMutationHookResult = ReturnType<typeof useSetSalesforceHouseholdObjectMutation>;
export type SetSalesforceHouseholdObjectMutationResult = Apollo.MutationResult<SetSalesforceHouseholdObjectMutation>;
export type SetSalesforceHouseholdObjectMutationOptions = Apollo.BaseMutationOptions<SetSalesforceHouseholdObjectMutation, SetSalesforceHouseholdObjectMutationVariables>;
export const SetSalesforceWealthHubBrandingDocument = gql`
    mutation SetSalesforceWealthHubBranding($id: ID!, $isWealthHub: Boolean!) {
  updateIntegrationConfiguration(
    input: {id: $id, update: {salesforceIsWealthhub: $isWealthHub}}
  ) {
    id
    salesforceIsWealthhub
  }
}
    `;
export type SetSalesforceWealthHubBrandingMutationFn = Apollo.MutationFunction<SetSalesforceWealthHubBrandingMutation, SetSalesforceWealthHubBrandingMutationVariables>;

/**
 * __useSetSalesforceWealthHubBrandingMutation__
 *
 * To run a mutation, you first call `useSetSalesforceWealthHubBrandingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSalesforceWealthHubBrandingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSalesforceWealthHubBrandingMutation, { data, loading, error }] = useSetSalesforceWealthHubBrandingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isWealthHub: // value for 'isWealthHub'
 *   },
 * });
 */
export function useSetSalesforceWealthHubBrandingMutation(baseOptions?: Apollo.MutationHookOptions<SetSalesforceWealthHubBrandingMutation, SetSalesforceWealthHubBrandingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSalesforceWealthHubBrandingMutation, SetSalesforceWealthHubBrandingMutationVariables>(SetSalesforceWealthHubBrandingDocument, options);
      }
export type SetSalesforceWealthHubBrandingMutationHookResult = ReturnType<typeof useSetSalesforceWealthHubBrandingMutation>;
export type SetSalesforceWealthHubBrandingMutationResult = Apollo.MutationResult<SetSalesforceWealthHubBrandingMutation>;
export type SetSalesforceWealthHubBrandingMutationOptions = Apollo.BaseMutationOptions<SetSalesforceWealthHubBrandingMutation, SetSalesforceWealthHubBrandingMutationVariables>;